module.exports = __webpack_public_path__ + "img/honey.798e6ced.gif";